(function () {
  'use strict';

  function PoofyCollectionGrid(section) {
    this.section = section;
    this.grid = section.querySelector('[data-pcg-grid]');
    this.sidebar = section.querySelector('[data-pcg-sidebar]');
    this.paginationEl = section.querySelector('[data-pcg-pagination]');
    this.emptyStateEl = section.querySelector('[data-pcg-empty-state]');
    this.sortSelect = section.querySelector('[data-pcg-sort-select]');
    this.clearBtn = section.querySelector('[data-pcg-clear-filters]');
    if (!this.grid) return;

    this.allProducts = Array.prototype.slice.call(this.grid.querySelectorAll('.pcg-product-card'));
    this.productsPerPage = this.grid.dataset.paginationEnabled === 'false'
      ? Infinity
      : (parseInt(this.grid.dataset.perPage, 10) || 24);

    this.state = {
      filters: {
        priceMin: null,
        priceMax: null,
        couleur: [],
        matiere: [],
        taille: [],
        reposepied: []
      },
      sort: 'best-selling',
      page: 1
    };

    this.visibleProducts = this.allProducts.slice();
    this.init();
  }

  PoofyCollectionGrid.prototype.init = function () {
    var facets = this.buildFacets();
    this.renderFacetGroup('couleur', facets.couleur);
    this.renderFacetGroup('matiere', facets.matiere);
    this.renderFacetGroup('taille', facets.taille);
    this.renderFacetGroup('reposepied', facets.reposepied);

    this.setupPriceMax();
    this.bindFilterEvents();
    this.bindSortEvent();
    this.bindClearEvent();
    this.bindPaginationClicks();

    this.applyAll();
  };

  // ---------- PRIX MAX (placeholder = prix le plus élevé de la collection courante) ----------
  PoofyCollectionGrid.prototype.setupPriceMax = function () {
    if (!this.allProducts.length) return;
    var maxCents = this.allProducts.reduce(function (max, card) {
      var price = parseInt(card.dataset.price, 10) || 0;
      return price > max ? price : max;
    }, 0);
    this.collectionMaxPrice = maxCents / 100;

    var priceMax = this.sidebar && this.sidebar.querySelector('[data-pcg-price-max]');
    if (priceMax) {
      var formatted = this.collectionMaxPrice % 1 === 0
        ? String(this.collectionMaxPrice)
        : this.collectionMaxPrice.toFixed(2);
      priceMax.placeholder = formatted;
      priceMax.max = formatted;
    }
  };

  // ---------- FACETS ----------
  PoofyCollectionGrid.prototype.buildFacets = function () {
    var facets = { couleur: new Map(), matiere: new Map(), taille: new Map(), reposepied: new Map() };
    var self = this;
    this.allProducts.forEach(function (card) {
      self.splitMulti(card.dataset.couleur, ',').forEach(function (v) { self.bump(facets.couleur, v); });
      self.splitMulti(card.dataset.matiere, ',').forEach(function (v) { self.bump(facets.matiere, v); });
      self.splitMulti(card.dataset.taille, '|').forEach(function (v) { self.bump(facets.taille, v); });
      if (card.dataset.reposePied === 'oui') self.bump(facets.reposepied, 'Repose-pied inclus');
    });
    return facets;
  };

  PoofyCollectionGrid.prototype.splitMulti = function (raw, sep) {
    if (!raw) return [];
    return raw.split(sep).map(function (v) { return v.trim(); }).filter(Boolean);
  };

  PoofyCollectionGrid.prototype.bump = function (map, key) {
    map.set(key, (map.get(key) || 0) + 1);
  };

  PoofyCollectionGrid.prototype.renderFacetGroup = function (groupKey, facetMap) {
    var detailsEl = this.sidebar && this.sidebar.querySelector('[data-pcg-filter-group="' + groupKey + '"]');
    if (!detailsEl) return;
    var divider = this.sidebar.querySelector('[data-pcg-divider-for="' + groupKey + '"]');
    var optionsEl = detailsEl.querySelector('[data-pcg-filter-options]');

    if (facetMap.size === 0) {
      detailsEl.hidden = true;
      if (divider) divider.hidden = true;
      return;
    }

    detailsEl.hidden = false;
    if (divider) divider.hidden = false;

    var sorted = Array.from(facetMap.entries()).sort(function (a, b) {
      return a[0].localeCompare(b[0], 'fr');
    });

    var self = this;
    optionsEl.innerHTML = sorted.map(function (entry) {
      var value = entry[0];
      var count = entry[1];
      return '<label class="pcg-filter-option">' +
        '<input type="checkbox" class="pcg-filter-checkbox" data-pcg-filter-group="' + groupKey + '" value="' + self.escapeAttr(value) + '">' +
        '<span>' + self.escapeHtml(value) + ' (' + count + ')</span>' +
        '</label>';
    }).join('');
  };

  // ---------- EVENTS ----------
  PoofyCollectionGrid.prototype.bindFilterEvents = function () {
    var self = this;
    if (!this.sidebar) return;

    this.sidebar.addEventListener('change', function (e) {
      var checkbox = e.target.closest('.pcg-filter-checkbox');
      if (!checkbox) return;
      var group = checkbox.dataset.pcgFilterGroup;
      var value = checkbox.value;
      var arr = self.state.filters[group];
      if (checkbox.checked) {
        if (arr.indexOf(value) === -1) arr.push(value);
      } else {
        self.state.filters[group] = arr.filter(function (v) { return v !== value; });
      }
      self.applyAll();
    });

    var priceMin = this.sidebar.querySelector('[data-pcg-price-min]');
    var priceMax = this.sidebar.querySelector('[data-pcg-price-max]');
    var onPriceChange = this.debounce(function () {
      self.state.filters.priceMin = priceMin.value ? Math.round(parseFloat(priceMin.value) * 100) : null;
      self.state.filters.priceMax = priceMax.value ? Math.round(parseFloat(priceMax.value) * 100) : null;
      self.applyAll();
    }, 350);
    if (priceMin) priceMin.addEventListener('input', onPriceChange);
    if (priceMax) priceMax.addEventListener('input', onPriceChange);
  };

  PoofyCollectionGrid.prototype.bindSortEvent = function () {
    var self = this;
    if (!this.sortSelect) return;
    this.sortSelect.addEventListener('change', function (e) {
      self.state.sort = e.target.value;
      self.applyAll();
    });
  };

  PoofyCollectionGrid.prototype.bindClearEvent = function () {
    var self = this;
    if (!this.clearBtn) return;
    this.clearBtn.addEventListener('click', function () {
      self.state.filters = { priceMin: null, priceMax: null, couleur: [], matiere: [], taille: [], reposepied: [] };
      if (self.sidebar) {
        self.sidebar.querySelectorAll('.pcg-filter-checkbox').forEach(function (cb) { cb.checked = false; });
        self.sidebar.querySelectorAll('[data-pcg-price-min], [data-pcg-price-max]').forEach(function (i) { i.value = ''; });
      }
      self.applyAll();
    });
  };

  PoofyCollectionGrid.prototype.bindPaginationClicks = function () {
    var self = this;
    if (!this.paginationEl) return;
    this.paginationEl.addEventListener('click', function (e) {
      var link = e.target.closest('[data-pcg-page]');
      if (!link) return;
      e.preventDefault();
      var page = link.dataset.pcgPage;
      self.state.page = page === 'next' ? self.state.page + 1 : parseInt(page, 10);
      self.renderPage();
      self.scrollToGridTop();
    });
  };

  // ---------- FILTER ----------
  PoofyCollectionGrid.prototype.applyAll = function () {
    this.filterProducts();
    this.sortProducts();
    this.state.page = 1;
    this.renderPage();
    this.updateClearButtonVisibility();
  };

  PoofyCollectionGrid.prototype.filterProducts = function () {
    var f = this.state.filters;
    var self = this;
    this.visibleProducts = this.allProducts.filter(function (card) {
      var price = parseInt(card.dataset.price, 10);
      if (f.priceMin !== null && price < f.priceMin) return false;
      if (f.priceMax !== null && price > f.priceMax) return false;
      if (f.couleur.length && !self.matchesAny(card.dataset.couleur, ',', f.couleur)) return false;
      if (f.matiere.length && !self.matchesAny(card.dataset.matiere, ',', f.matiere)) return false;
      if (f.taille.length && !self.matchesAny(card.dataset.taille, '|', f.taille)) return false;
      if (f.reposepied.length && card.dataset.reposePied !== 'oui') return false;
      return true;
    });
  };

  PoofyCollectionGrid.prototype.matchesAny = function (raw, sep, selected) {
    var values = this.splitMulti(raw, sep);
    return selected.some(function (sel) { return values.indexOf(sel) !== -1; });
  };

  // ---------- SORT ----------
  PoofyCollectionGrid.prototype.sortProducts = function () {
    var arr = this.visibleProducts;
    switch (this.state.sort) {
      case 'price-asc':
        arr.sort(function (a, b) { return parseInt(a.dataset.price, 10) - parseInt(b.dataset.price, 10); });
        break;
      case 'price-desc':
        arr.sort(function (a, b) { return parseInt(b.dataset.price, 10) - parseInt(a.dataset.price, 10); });
        break;
      case 'title-asc':
        arr.sort(function (a, b) { return a.dataset.title.localeCompare(b.dataset.title, 'fr'); });
        break;
      case 'title-desc':
        arr.sort(function (a, b) { return b.dataset.title.localeCompare(a.dataset.title, 'fr'); });
        break;
      case 'date-new-old':
        arr.sort(function (a, b) { return parseInt(b.dataset.createdAt, 10) - parseInt(a.dataset.createdAt, 10); });
        break;
      case 'date-old-new':
        arr.sort(function (a, b) { return parseInt(a.dataset.createdAt, 10) - parseInt(b.dataset.createdAt, 10); });
        break;
      case 'best-selling':
      default:
        arr.sort(function (a, b) { return parseInt(a.dataset.index, 10) - parseInt(b.dataset.index, 10); });
        break;
    }
  };

  // ---------- PAGINATION + RENDER ----------
  PoofyCollectionGrid.prototype.renderPage = function () {
    var totalItems = this.visibleProducts.length;
    var totalPages = Math.max(1, Math.ceil(totalItems / this.productsPerPage));
    if (this.state.page > totalPages) this.state.page = totalPages;

    var startIdx = (this.state.page - 1) * this.productsPerPage;
    var endIdx = startIdx + this.productsPerPage;
    var pageItems = new Set(this.visibleProducts.slice(startIdx, endIdx));

    this.allProducts.forEach(function (card) { card.style.display = 'none'; });

    var grid = this.grid;
    this.visibleProducts.forEach(function (card) { grid.appendChild(card); });
    pageItems.forEach(function (card) { card.style.display = ''; });

    // Alternance lifestyle / personne : 1 carte visible sur 3 affiche la personne
    var n = 0;
    pageItems.forEach(function (card) {
      n++;
      if (card.querySelector('.pcg-product-image--hover')) {
        card.classList.toggle('pcg-card--personne', n % 3 === 0);
      }
    });

    if (this.emptyStateEl) this.emptyStateEl.hidden = totalItems !== 0;

    this.renderPaginationControls(this.state.page, totalPages);
  };

  PoofyCollectionGrid.prototype.renderPaginationControls = function (current, total) {
    if (!this.paginationEl) return;
    if (total <= 1) {
      this.paginationEl.innerHTML = '';
      return;
    }

    var self = this;
    var pages = this.computePageList(current, total);
    var items = pages.map(function (p) {
      if (p === 'ellipsis') return '<span class="pcg-page-ellipsis">…</span>';
      var isCurrent = p === current;
      return '<a href="#" class="pcg-page-link' + (isCurrent ? ' pcg-page-link--current' : '') + '" ' +
        'data-pcg-page="' + p + '" aria-current="' + (isCurrent ? 'page' : 'false') + '">' + p + '</a>';
    }).join('');

    var nextArrow = current < total
      ? '<a href="#" class="pcg-page-arrow" data-pcg-page="next" aria-label="Page suivante">›</a>'
      : '';

    this.paginationEl.innerHTML = '<div class="pcg-page-list">' + items + nextArrow + '</div>';
  };

  PoofyCollectionGrid.prototype.computePageList = function (current, total) {
    var delta = 1;
    var range = [];
    for (var i = 1; i <= total; i++) {
      if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
        range.push(i);
      }
    }
    var withEllipsis = [];
    var prev = null;
    range.forEach(function (p) {
      if (prev !== null && p - prev > 1) withEllipsis.push('ellipsis');
      withEllipsis.push(p);
      prev = p;
    });
    return withEllipsis;
  };

  PoofyCollectionGrid.prototype.scrollToGridTop = function () {
    this.grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  PoofyCollectionGrid.prototype.updateClearButtonVisibility = function () {
    var f = this.state.filters;
    var hasActive = f.priceMin !== null || f.priceMax !== null ||
      f.couleur.length || f.matiere.length || f.taille.length || f.reposepied.length;
    if (this.clearBtn) this.clearBtn.hidden = !hasActive;
  };

  PoofyCollectionGrid.prototype.debounce = function (fn, delay) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, delay);
    };
  };

  PoofyCollectionGrid.prototype.escapeHtml = function (str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  PoofyCollectionGrid.prototype.escapeAttr = function (str) {
    return this.escapeHtml(str);
  };

  function initAll(root) {
    (root || document).querySelectorAll('[data-pcg-grid]').forEach(function (grid) {
      var section = grid.closest('[data-section-id]');
      if (!section || section.dataset.pcgInitialized) return;
      section.dataset.pcgInitialized = 'true';
      new PoofyCollectionGrid(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  }
})();
